import { createFileRoute, Outlet, redirect } from "@tanstack/react-router";
import { supabase } from "@/integrations/supabase/client";

export const Route = createFileRoute("/_authenticated")({
  ssr: false,
  beforeLoad: async () => {
    // Local session gate; serverFns still validate the Bearer JWT.
    const { data, error } = await supabase.auth.getSession();
    if (error || !data.session?.user) {
      // Full document load in the browser avoids soft-redirect hydration
      // mismatches on ssr:false. Soft redirect in Vitest so renderApp can assert.
      throw redirect({
        to: "/auth",
        reloadDocument: !import.meta.env.VITEST,
      });
    }
    return { user: data.session.user };
  },
  component: () => <Outlet />,
});
